import { DEFAULT_PATH_COLOR } from "../constants/colors";
import { SPECIES_TYPE } from "../constants/enums";
import { DEFAULT_SOLID_PATTERN, DEFAULT_STROKE_OPACITY, HIGHLIGHTED_STROKE_WIDTH } from "../constants/style";
import { SharkSpecies } from "./shark-species";
import { sha256 } from "js-sha256";
export class SharkTreeNode {
    constructor(sharkTreeConfig, parent = null, speciesType = SPECIES_TYPE.SHARKS) {
        var _a;
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "children", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "parent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "speciesType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "childPaths", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "parentPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "node", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = sharkTreeConfig;
        this.parent = parent;
        this.speciesType = speciesType;
        this.children = [];
        this.childPaths = [];
        this.parentPath = [];
        (_a = this.config.children) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
            if (child.hasOwnProperty("children"))
                this.addChild(new SharkTreeNode(child, this, this.speciesType));
            else
                this.addChild(new SharkSpecies(child, this, this.speciesType));
        });
        this.hash = this.getHash();
    }
    /*----------------------------------------|
    |                GETTERS                  |
    |----------------------------------------*/
    getHash() {
        if (this.hash)
            return this.hash;
        const jsonString = JSON.stringify(this.config);
        return sha256(jsonString).toString();
    }
    getHashChain() {
        let hashChain = [this.getHash()];
        let parent = this.getParent();
        while (parent !== null) {
            hashChain.push(parent.getHash());
            parent = parent.getParent();
        }
        return hashChain;
    }
    getParent() {
        return this.parent;
    }
    getParentPath() {
        return this.parentPath;
    }
    getLastChildPathSegment() {
        const firstChildPathLength = this.childPaths[0].length;
        return this.childPaths[0][firstChildPathLength - 1];
    }
    getLastParentPathSegment() {
        const parentPathLength = this.parentPath.length;
        return this.parentPath[parentPathLength - 1];
    }
    getParentHash() {
        var _a;
        return (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getHash();
    }
    /*----------------------------------------|
    |                ADDERS                   |
    |----------------------------------------*/
    addChildPath(childPath) {
        this.childPaths.push(childPath);
    }
    addChild(child) {
        this.children.push(child);
    }
    addParentPathSegment(parentPathSegment) {
        this.parentPath.push(parentPathSegment);
    }
    addParentPathToParentChildPath() {
        var _a;
        const parentPath = this.getParentPath();
        (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addChildPath(parentPath);
    }
    /*----------------------------------------|
    |              HIGHLIGHTING               |
    |----------------------------------------*/
    highlightParentPath(strokeWidth = HIGHLIGHTED_STROKE_WIDTH, strokeColor = DEFAULT_PATH_COLOR, strokeOpacity = DEFAULT_STROKE_OPACITY, dashPattern = DEFAULT_SOLID_PATTERN) {
        this.parentPath.forEach(segment => segment.setAttribute("stroke", strokeColor));
        this.parentPath.forEach(segment => segment.setAttribute("stroke-width", `${strokeWidth}`));
        this.parentPath.forEach(segment => segment.setAttribute("stroke-opacity", `${strokeOpacity}`));
        this.parentPath.forEach(segment => dashPattern === "solid" ? segment.removeAttribute("stroke-dasharray") : segment.setAttribute("stroke-dasharray", dashPattern));
    }
}
